<template>
  <span class="scaling-svg-container">
    <svg xmlns="http://www.w3.org/2000/svg" width="37" height="37" viewBox="0 0 37 37" class="scaling-svg">
      <g transform="translate(-1.308 0)">
        <circle cx="18.5" cy="18.5" r="18.5" transform="translate(1.308 0)" fill="#fff" />
        <g transform="translate(18.308 9.999)">
          <rect width="3" height="12" rx="1.5" fill="#ffc845" />
          <circle cx="1.5" cy="1.5" r="1.5" transform="translate(0 14)" fill="#ffc845" />
        </g>
      </g>
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class DialogWarningIcon extends Vue {}
</script>

<style></style>
